import React from "react";

function PlatformStrategy() {
  return (
    <>
      <div
        className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
        style={{
          backgroundImage:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
        }}
      >
        <div className="container">
          <div className="site-heading">
            <div className="row align-center">
              <div className="col-lg-6">
                <h4 className="sub-title">Our Process</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our Crypto Launchpad Development Process
                </h2>
              </div>
              <div className="col-lg-5 offset-lg-1">
                <p>
                  Artificial Intelligence refers to the development of computer
                  systems that can perform tasks that would typically require
                  human intelligence. It involves the creation of algorithms and
                  models that enable.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="process-style-two-items">
            <div className="row">
              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>01</span>
                  <h4>Platform Strategy & Planning</h4>
                  <p>
                    Aligning your vision with a tailored development plan to
                    create a high-performing, secure, and compliant launchpad.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>02</span>
                  <h4>Custom Development & Blockchain Integration</h4>
                  <p>
                    Developing the platform with advanced features and
                    integrating with multiple blockchains to maximize project
                    flexibility.
                  </p>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>03</span>
                  <h4>Security Audits & Quality Assurance</h4>
                  <p>
                    Comprehensive testing and smart contract audits to ensure
                    platform security and smooth operation.
                  </p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 process-two-single">
                <div className="process-style-two-item">
                  <span>04</span>
                  <h4>Launch & Continuous Support</h4>
                  <p>
                    Supporting you through the launch and offering ongoing
                    assistance, updates, and enhancements to optimize platform
                    success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlatformStrategy;
